import { createContext } from 'react';

import type { CurrentAmplifyUser } from '../api/ampUser';

export interface AmplifyUserContextValue {
  user: CurrentAmplifyUser | null | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  // Methods to interact with the cache:
  refetchUser: () => void;
  clearUserCache: () => void;
}

export const AmplifyUserContext = createContext<
  AmplifyUserContextValue | undefined
>(undefined);

AmplifyUserContext.displayName = 'AmplifyUserContext';
